<template>
  <div>
    <div style="display: flex;flex-direction: row;margin-bottom: 10px;">
      <el-button size="mini" v-if="order_carry_over.status==1" @click="backOrder">撤 销</el-button>
    </div>
    <div class="main-sell">
      <el-descriptions size="mini" :column="1" border direction="vertical">
        <el-descriptions-item label="应收款明细信息">
          <div>
            <el-descriptions size="mini" :label-style="{width: '80px'}" :column="1" border>
              <el-descriptions-item label="客户">
                <el-row :gutter="5">
                  <el-col :span="12">
                    <el-descriptions size="mini" :label-style="{width: '80px'}" :column="1" border>
                      <el-descriptions-item label="老客户">{{customer_old.name}}（<el-link type="primary" @click="showEditor(customer_old.id)">{{customer_old.id}}</el-link>）</el-descriptions-item>
                      <el-descriptions-item label="证件编号">{{customer_old.credentials_code}}</el-descriptions-item>
                      <el-descriptions-item label="手机号码">{{customer_old.contact_number}}</el-descriptions-item>
                    </el-descriptions>
                  </el-col>
                  <el-col :span="12">
                    <el-descriptions size="mini" :label-style="{width: '80px'}" :column="1" border>
                      <el-descriptions-item label="新客户">{{customer_new.name}}（<el-link type="primary" @click="showEditor(customer_new.id)">{{customer_new.id}}</el-link>）</el-descriptions-item>
                      <el-descriptions-item label="证件编号">{{customer_new.credentials_code}}</el-descriptions-item>
                      <el-descriptions-item label="手机号码">{{customer_new.contact_number}}</el-descriptions-item>
                    </el-descriptions>
                  </el-col>
                </el-row>
              </el-descriptions-item>
              <el-descriptions-item label="结转日期">
                {{order_carry_over.carry_down_date}}
                <span style="color: #ff0000"> &nbsp;&nbsp;&nbsp;&nbsp;*&nbsp;&nbsp;结转时间必须选择（选择之日起即就是新客户的）</span>
              </el-descriptions-item>
              <el-descriptions-item label="结转备注">
                {{order_carry_over.remarks}}
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <div style="display: flex;flex-direction: row">
            <div style="width: 50%;display: grid;">
              <el-table
                :data="order_carry_over.now_order_data"
                border
                style="width: 100%" height="40vh">
                <el-table-column prop="customer_name" label="客户名称" align="center" width="180" fixed></el-table-column>
                <el-table-column prop="h_name_date" label="房 产" align="center" width="320"></el-table-column>
                <el-table-column prop="ChargeItemName" label="收费标准" align="center" width="240"></el-table-column>
                <el-table-column prop="startDate" label="计费周期" align="center" width="240">
                  <template slot-scope="scope">
                    {{scope.row.startDate}} - {{scope.row.endDate}}
                  </template>
                </el-table-column>
                <el-table-column prop="should_charge_date" label="应收日期" align="center" width="150"></el-table-column>
                <el-table-column prop="charge" label="应收金额" align="center" width="90"></el-table-column>
                <el-table-column prop="PaidChargeSum" label="已收金额" align="center" width="90"></el-table-column>
              </el-table>
            </div>
            <div style="width: 50%;display: grid;">
              <el-table
                :data="order_carry_over.new_order_data"
                border
                style="width: 100%" height="40vh">
                <el-table-column prop="customer_name" label="客户名称" align="center" width="180" fixed></el-table-column>
                <el-table-column prop="h_name_date" label="房 产" align="center" width="320"></el-table-column>
                <el-table-column prop="ChargeItemName" label="收费标准" align="center" width="240"></el-table-column>
                <el-table-column prop="startDate" label="计费周期" align="center" width="240">
                  <template slot-scope="scope">
                    {{scope.row.startDate}} - {{scope.row.endDate}}
                  </template>
                </el-table-column>
                <el-table-column prop="should_charge_date" label="应收日期" align="center" width="150"></el-table-column>
                <el-table-column prop="charge" label="应收金额" align="center" width="90"></el-table-column>
                <el-table-column prop="PaidChargeSum" label="已收金额" align="center" width="90"></el-table-column>
              </el-table>
            </div>
          </div>


        </el-descriptions-item>
      </el-descriptions>
    </div>

    <editor v-model="editor.visable" :classValue="editor.classValue" :id="editor.id" :is_edit="false" @callback="editorCallback" />
  </div>
</template>

<script>
import Editor from "../../../Customer/editor";
import moment from "moment";

export default {
  name: "SaleCarryOverDetails",
  components:{Editor},
  inject:['setComponents','onEventHandel'],
  props:{
    customerOldId:[Number,String],
    customerNewId:[Number,String],
    houseId:[Number,String],
    Id:[Number,String]
  },
  data(){
    return{
      loading:false,
      visable:false,
      form:{
        carry_forward_date:""
      },
      chang_name_ids:[],
      multipleSelection:[],
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      callback:null,
      chang_name_list:[],
      customer_old:{},
      customer_new:{},
      editor:{
        classValue:1,
        id:0,
        visable:false
      },
      remarks:"",
      order_carry_over:{}
    }
  },
  mounted() {
    const that=this;
    that.house_id=that.houseId;
    that.getOrderCarryOver()
    that.getCustomerBaseObj()
  },
  methods:{
    getCustomerBaseObj(){
      const that=this;
      ERP.postRequest({url: "admin/SaleCarryOver/getCustomerBaseObj", data: {
          customer_old_id:that.customerOldId,
          customer_new_id:that.customerNewId,
        }
      }, res => {
        if (res.code) {
          that.customer_old=res.data.customer_old||{};
          that.customer_new=res.data.customer_new||{};
        }
      })
    },

    getOrderCarryOver(){
      const that=this;
      ERP.postRequest({url: "admin/SaleCarryOver/getOrderCarryOver", data: {
          id:that.Id,
        }
      }, res => {
        if (res.code) {
          // console.log(res.data)
          that.order_carry_over=res.data
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    hide(){
      this.onEventHandel()
    },
    backOrder(){
      const that=this;
      ERP.postRequest({url: "admin/SaleCarryOver/backOrder", data: {
          id:that.Id,
        }
      }, res => {
        if (res.code) {
          that.$message.success("撤销成功")
        }else {
          that.$message.error(res.msg||"撤销异常")
        }
      })
    },
    showEditor(customer_id) {
      const that=this;
      that.getCustomerBase(customer_id,data=>{
        that.editor.classValue = data.class
        that.editor.id = customer_id
        that.editor.visable = true
      })
    },
    getCustomerBase(customer_id,callback){
      ERP.getRequest({
        url: "admin/Customer/getCustomerBase",
        data: {
          id: customer_id,
        }
      }, res => {
        if (res.code) {
          typeof callback ==="function"&&callback(res.data);
        }
      })
    },
    editorCallback(arg) {
      // this.getList()
      if(arg && arg[0]) this.editor.id = arg[0]
    },
    setComponentsId(componentsId){
      this.setComponents(componentsId)
    }
  }
}
function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
.main-sell{
  //height: calc(100vh - 300px);
  //overflow-y: scroll;
}
>>>.el-table--border, .el-table--group{
  border: 1px solid #000000;
}
>>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
  border-bottom: 1px solid #000000;
}
>>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
  border-right: 1px solid #000000;
}
>>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
  border-bottom: 1px solid #000000;
}
>>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
  border-bottom: 1px solid #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/SaleCarryOverDetails.vue